import type {ReactNode} from 'react'
import React from 'react'

interface Navigate {
    next: () => void
    prev: () => void
    goToStep: (step: number) => void
}

interface Context {
    activeStepIndex: number
    totalSteps: number
    navigate: Navigate
}

interface ContextProviderProps extends Context {
    children: ReactNode
}

const StepsContext = React.createContext<Context>({
    activeStepIndex: 0,
    totalSteps: 0,
    navigate: {
        next: () => {},
        prev: () => {},
        goToStep: () => {},
    },
})

export const useSteps = () => React.useContext(StepsContext)

export const StepsProvider = ({children, ...props}: ContextProviderProps) => (
    <StepsContext.Provider value={props}>{children}</StepsContext.Provider>
)
